// extracted by mini-css-extract-plugin
export default {"container":"ReEligibilityModal_container__fKnl8","title":"ReEligibilityModal_title__E2ijd","desc":"ReEligibilityModal_desc__DeVhz"};